// Dont reference this.
import axios from 'axios';

export default class ShopifyCartProvider {
  static getShippingRates(zip, country, province) {
    const url = `/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static updateCart(data, endpoint) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/cart/${endpoint}`, { ...data })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static getCart() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/cart.js?tmp=${Date.now()}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static addItem(id, quantity, properties = {}) {
    return this.updateCart({ id, quantity, properties }, 'add.js');
  }

  static reload() {
    return ShopifyCartProvider.getCart();
  }

  static clearCart() {
    return ShopifyCartProvider.updateCart(null, 'clear.js');
  }

  static updateNote(note) {
    return ShopifyCartProvider.updateCart({ note }, 'update.js');
  }

  static updateAttributes(attributes) {
    return ShopifyCartProvider.updateCart({ attributes }, 'update.js');
  }

  static updateQuantity(key, quantity) {
    return ShopifyCartProvider.updateCart({ id: key, quantity }, 'change.js');
  }
}
